import React, { useState, useEffect } from "react";
import "./App.css";
import Header from "./Header";
import { useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const LoginPage = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    window.onbeforeunload = function () {
      sessionStorage.clear();
    };

    const loggedIn = sessionStorage.getItem("loggedIn");
    if (loggedIn) {
      navigate("/ladyirwin");
    }
  }, [navigate]);

  const handleUsernameChange = (e) => {
    setUsername(e.target.value);
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const url = `${process.env.REACT_APP_BASE_URL}/ladyirwin-api/verifyLogin`;
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          username: username,
          password: password,
        }),
      });

      if (response.ok) {
        const data = await response.text();
        if (data === "Login successful") {
          const token = btoa(`${username}:${password}`);
          sessionStorage.setItem("loggedIn", "true");
          sessionStorage.setItem("authToken", token); // Store the token
          navigate("/ladyirwin/student-details");
        } else {
          setError("Invalid username or password");
        }
      } else {
        setError("Invalid username or password");
      }
    } catch (error) {
      setError("Error verifying login details");
    }
  };

  return (
    <div className="container">
      <Header />
      <div className="login-container">
        <form className="login-form" onSubmit={handleSubmit}>
          <h2>Admin Login</h2>
          <div className="email-group">
            <label htmlFor="email">Username</label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={handleUsernameChange}
              required
            />
          </div>
          <div className="password-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={handlePasswordChange}
              required
            />
          </div>
          <button className="login-button" type="submit">
            Login
          </button>
          {error && <p style={{ color: "red" }}>{error}</p>}
        </form>
      </div>
      <ToastContainer />
    </div>
  );
};

export default LoginPage;
